import { render, staticRenderFns } from "./block.vue?vue&type=template&id=402ca95c&scoped=true&"
import script from "./block.vue?vue&type=script&lang=ts&"
export * from "./block.vue?vue&type=script&lang=ts&"
import style0 from "./block.vue?vue&type=style&index=0&id=402ca95c&scoped=true&lang=css&"
import style1 from "./block.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402ca95c",
  null
  
)

export default component.exports